"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class EcsClient {
    getConfig(config) {
        return fetch(encodeURI(`${config.host}/config/v1/${config.clientName}/` +
            `${config.clientVersion}/${config.projectTeam}`)).then((value) => {
            return value.json();
        });
    }
}
exports.EcsClient = EcsClient;
const ecsClient = new EcsClient();
exports.default = ecsClient;
